import React, { useEffect, useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import api from "../lib/api";

/**
 * Catch-all route that consults the admin-managed redirect map at
 * `/api/public/redirects` and issues a client-side redirect for any legacy
 * Wix path. Falls back to the NotFound page once the map is loaded and the
 * current path is NOT in it.
 *
 * This is a 302-like client redirect; for true 301s we'd need an edge
 * config in production hosting. Googlebot renders JS and will follow these
 * as soft redirects, preserving most ranking equity.
 */
export default function LegacyRedirect({ fallback }) {
  const location = useLocation();
  const [map, setMap] = useState(null);

  useEffect(() => {
    api.get("/public/redirects").then((r) => setMap(r.data || {})).catch(() => setMap({}));
  }, []);

  if (map === null) {
    // Loading — render nothing so we don't flash the NotFound page
    return null;
  }

  const path = location.pathname.replace(/\/+$/, "") || "/";
  const target = map[path] || map[`${path}/`];
  if (target && target !== path) {
    return <Navigate to={`${target}${location.search}`} replace />;
  }

  return fallback;
}
